import { createUnistyles } from 'react-native-unistyles'
import { breakpoints } from './breakpoints'
import { lightTheme } from './theme'

export const { createStyleSheet: createStyles, useStyles } = createUnistyles<typeof breakpoints, typeof lightTheme>(breakpoints)
